import { Roles } from "@/enums";
import { IReturn, ReturnTypesEnum } from "@/interfaces/Return";

export const IS_RTO_QUERY_PARAM = "isRTO";

export const withRtoQuery = (pathname: string): string =>
  `${pathname}?${IS_RTO_QUERY_PARAM}=true`;

export const CANCELLATION_QUERY_PARAM = "annulation";

// Le livreur ne filtre plus par isRTO : il bascule entre les tournées en cours
// de livraison et celles en annulation, qui ont leur propre endpoint.
export const usesCancellationListFilter = (roles: string): boolean =>
  roles.includes(Roles.DELIVERY_ROLE);

export const canAccessRtoListFilter = (roles: string): boolean =>
  roles.includes(Roles.EXPEDITION_ROLE) && !roles.includes(Roles.DELIVERY_ROLE);

export const canAccessRtoBulkPickup = (roles: string): boolean =>
  roles.includes(Roles.DELIVERY_ROLE) ||
  roles.includes(Roles.EXPEDITION_ROLE);

export const usesExpeditionBulkValidation = (roles: string): boolean =>
  roles.includes(Roles.EXPEDITION_ROLE) &&
  !roles.includes(Roles.DELIVERY_ROLE);

export const isRtoReturn = (return_: IReturn): boolean =>
  return_.typeTournee === ReturnTypesEnum.RTO_EMM ||
  return_.typeTournee === ReturnTypesEnum.RTO_HUB;
